export const BRAND_NAME = 'Jannatexch9xyz';
// Note: It is the main site url. Ex - sky11.com, etc.
export const BRAND_DOMAIN = 'jannatexch9.xyz';
export const PROVIDER_ID = 'BetFair';
